import { MarketBrief } from 'models/market'
import { formatNumber } from 'utils/format-number'
import { t9n } from 't9n/t9n'

const $ratesTimerWrapper = document.querySelector<HTMLDivElement>('[data-js-selector="rates-timer-wrapper"]')
const $ratesTimerText = document.querySelector<HTMLDivElement>('[data-js-selector="rates-timer-text"]')
const $ratesTimerSec = document.querySelector<HTMLDivElement>('[data-js-selector="rates-timer-sec"]')
const $buyElement = document.querySelector<HTMLSpanElement>('[data-rates-direction="buy"]')
const $sellElement = document.querySelector<HTMLSpanElement>('[data-rates-direction="sell"]')
const $forexElement = document.querySelector<HTMLSpanElement>('[data-rates-direction="forex"]')
const $ratesDirectionChange = document.querySelector<HTMLSpanElement>('[data-rates-direction="change"]')
const $ratesDirectionIcon = document.querySelector<HTMLSpanElement>('[data-js-selector="rates-direction-icon"]')

let secondsToUpdate = 10
let intervalId: number | undefined

function checkTimer(): void {
  if (secondsToUpdate > 0) {
    secondsToUpdate--
    if ($ratesTimerWrapper) {
      $ratesTimerWrapper.textContent = `${secondsToUpdate}`
      $ratesTimerWrapper.removeAttribute('hidden')
      $ratesTimerText.removeAttribute('hidden')
      $ratesTimerSec.textContent = `${t9n('ratesUpdate.timeUnit')}`
    }
    if (secondsToUpdate === 0) {
      $ratesTimerWrapper.setAttribute('hidden', '')
      $ratesTimerText.setAttribute('hidden', '')
      $ratesTimerSec.textContent = `${t9n('ratesUpdate.update')}`
    }
  }
}

function getDirection(oldRate: number, newRate: number): string {
  if (oldRate - newRate > 0) {
    return 'is-down'
  } else if (oldRate - newRate === 0) {
    return ''
  }
  return 'is-up'
}

function getPercentage(oldRate: number, newRate: number): string {
  let percentage = oldRate !== 0 ? parseFloat((((newRate - oldRate) / oldRate) * 100).toFixed(2)) : 0
  if (percentage === 0) {
    percentage = parseFloat((((newRate - oldRate) / oldRate) * 100).toFixed(3))
  }
  if (percentage === Infinity) {
    percentage = 0
  }
  return percentage !== 0 ? `${percentage.toString().replace('.', ',')}%` : '—'
}

function setRateChange(pair: MarketBrief): void {
  const { forexOld, forexNow } = pair.directExchangeOffers
  if ($ratesDirectionChange) $ratesDirectionChange.textContent = getPercentage(forexOld, forexNow)
  if ($ratesDirectionChange)
    $ratesDirectionChange.setAttribute('class', `bem-single-rate-box__direction ${getDirection(forexOld, forexNow)}`)
  if ($ratesDirectionIcon)
    $ratesDirectionIcon.setAttribute('class', `bem-single-rate-box__icon ${getDirection(forexOld, forexNow)}`)
}

function setRates(buyNow: number, sellNow: number, forexNow: number): void {
  if ($buyElement) $buyElement.textContent = formatNumber(buyNow, 4)
  if ($sellElement) $sellElement.textContent = formatNumber(sellNow, 4)
  if ($forexElement) $forexElement.textContent = formatNumber(forexNow, 4)
}

function updateRates(): void {
  secondsToUpdate = 10

  const offers = window.pairMarketBrief?.directExchangeOffers

  if (!offers) {
    console.error('empty pairMarketBrief')
    return handleError()
  }

  const { buyNow, sellNow, forexNow } = offers
  setRates(buyNow, sellNow, forexNow)
  setRateChange(window.pairMarketBrief)
  if ($ratesTimerText) $ratesTimerText.textContent = `${t9n('ratesUpdate.success')}`
}

function handleError(): void {
  secondsToUpdate = 10
  if ($ratesTimerText) $ratesTimerText.textContent = `${t9n('ratesUpdate.error')}`
}

export default function initChartRates(): void {
  if (intervalId) {
    clearInterval(intervalId)
  }
  intervalId = window.setInterval(checkTimer, 1000)
  window.addEventListener('pairMarketBrief fetched', updateRates)
  window.addEventListener('pairMarketBrief fetch fail', handleError)
}
